import React from "react";

export const useBrowserTabTitle = title => {
	React.useEffect(() => {
		const initialTitle = document.title;
		document.title = title;

		return () => {
			document.title = initialTitle;
		};
	}, [title]);
};
